import { providerClassLib, type hashCodeLib } from 'shared';
import type { flightEntity } from 'freedom-shared';

type Offer = flightEntity.types.MappedOffer;
type SearchParams = ReturnType<typeof hashCodeLib.getSearchParams>;

export const QUICK_BOOKING_INELIGIBLE_REASON = {
  CHARTER_OR_FUNSUN: 'charter_or_funsun',
} as const;

export type QuickBookingIneligibleReason =
  (typeof QUICK_BOOKING_INELIGIBLE_REASON)[keyof typeof QUICK_BOOKING_INELIGIBLE_REASON];

export const getQuickBookingIneligibleReason = (
  offer: Offer,
  _searchParams: SearchParams,
): QuickBookingIneligibleReason | null => {
  // FunSun / charter stays excluded — it carries its own document-form
  // requirements and hasn't been validated inside QuickBooking yet.
  // Everything else (including connecting flights) is rolled out into the
  // QuickBooking flow.
  if (providerClassLib.isFunSun(offer.$meta?.provider_class ?? '')) {
    return QUICK_BOOKING_INELIGIBLE_REASON.CHARTER_OR_FUNSUN;
  }

  return null;
};

export const isQuickBookingEligible = (
  offer: Offer,
  searchParams: SearchParams,
): boolean => {
  return getQuickBookingIneligibleReason(offer, searchParams) === null;
};
